module.exports = __webpack_public_path__ + "static/media/avison_young.4794dbe5.png";